/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online text to binary converter. Turn any text into 8-bit binary and decode binary back to text. UTF-8 safe and works in your browser.`)
};

const es_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor en línea gratuito de texto a binario. Convierte cualquier texto en binario de 8 bits y decodifica binario de vuelta a texto. Compatible con UTF-8 y funciona en tu navegador.`)
};

const de_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Text-zu-Binär-Konverter. Wandle jeden Text in 8-Bit-Binärcode um und dekodiere Binärcode zurück in Text. UTF-8-sicher und funktioniert in deinem Browser.`)
};

const nl_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online tekst-naar-binair converter. Zet willekeurige tekst om in 8-bits binair en decodeer binair terug naar tekst. UTF-8 veilig en werkt in uw browser.`)
};

const fr_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur gratuit en ligne de texte en binaire. Convertissez n'importe quel texte en binaire 8 bits et décodez le binaire en texte. Compatible UTF-8 et fonctionne dans votre navigateur.`)
};

const it_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore da testo a binario online gratuito. Converti qualsiasi testo in binario a 8 bit e decodifica il binario di nuovo in testo. Sicuro per UTF-8 e funziona nel tuo browser.`)
};

const pt_br2_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor online gratuito de texto para binário. Converta qualquer texto em binário de 8 bits e decodifique binário de volta para texto. Seguro para UTF-8 e funciona no seu navegador.`)
};

const pt_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de texto para binário online gratuito. Converta qualquer texto em binário de 8 bits e descodifique binário de volta para texto. Seguro para UTF-8 e funciona no seu navegador.`)
};

const ja_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストをバイナリに変換する無料オンラインツール。任意のテキストを 8 ビットのバイナリに変換し、バイナリをテキストにデコードしてください。UTF-8 対応、ブラウザで動作します。`)
};

const zh_tb_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线文本转二进制转换器。将任意文本转换为8位二进制,并将二进制解码回文本。兼容UTF-8,可在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_meta_description", locale)
	if (locale === "en") return en_tb_meta_description(inputs)
	if (locale === "es") return es_tb_meta_description(inputs)
	if (locale === "de") return de_tb_meta_description(inputs)
	if (locale === "nl") return nl_tb_meta_description(inputs)
	if (locale === "fr") return fr_tb_meta_description(inputs)
	if (locale === "it") return it_tb_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_tb_meta_description(inputs)
	if (locale === "pt") return pt_tb_meta_description(inputs)
	if (locale === "ja") return ja_tb_meta_description(inputs)
	return zh_tb_meta_description(inputs)
};